import React from 'react';
import styled from 'styled-components';
import { ImageLink } from '../Link';
import { IMAGE_TYPE } from '../../constants';
import { ICON_SIZE } from '../../constants';
import media from '../../utils/media';
import { isFieldValid } from '../../utils/validation';
const IconContainer = styled.div `
  margin: 3%;
  display: flex;
  ${media.mobile} {
    margin: 4%;
  }
  @media (min-width: 1563px) {
    margin: 4%;
  }
  @media (min-width: 1923px) {
    margin: 3% 5%;
  }
  @media (min-width: 2500px) {
    margin: 3% 6%;
  }
`;
export const Icon = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { image, url } = fields;
    return (React.createElement(IconContainer, null, isFieldValid(image) && (React.createElement(ImageLink, { media: image, linkField: url, type: IMAGE_TYPE.ICON, desktopWidth: ICON_SIZE.DESKTOP_WIDTH, desktopHeight: ICON_SIZE.DESKTOP_HEIGHT, mobileWidth: ICON_SIZE.MOBILE_WIDTH, mobileHeight: ICON_SIZE.MOBILE_HEIGHT }))));
};
export default Icon;
